import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/oreetiene/public_html/components/othersPages/contact/ContactForm.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/oreetiene/public_html/node_modules/lucide-react/dist/esm/Icon.mjs");
